<div class="header__loader" *ngIf="isLoading">
  <app-loading [onlyIcon]="true"></app-loading>
  {{ 'COMMONS.LOADING' | i18nextEager }}
</div>
<header>
  <img class="menu element" (click)="menuClicked($event)"
    [src]="!isMenuOpen ? '/assets/icons/menu.svg' : '/assets/icons/menu-close.svg'" alt="Menu" />
  <img src="/assets/icons/logo.svg" alt="{{ 'COMMONS.ACCIONA_LOGO' | i18nextEager }}" class="element" />
  <div class="element container-title">
    <span *ngIf="routeLabel" class="separator"></span>
    <span *ngIf="routeLabel" class="subtitle">&nbsp;{{ routeLabel | i18nextEager | uppercase }}</span>
  </div>
  <div class="space"></div>
  <div *ngIf="contractsNotifications.length > 0 && !onlyCanRead" class="header__container-notifications">
    <span (click)="handleNotifications()" class="header__circle-notifications" #notificationsButton>
      {{ contractsNotifications.length }}
    </span>
    <div *ngIf="openedNotifications" class="header__box-notifications" #notificationsPanel>
      <img src="/assets/icons/close.svg" (click)="handleNotifications()" class="header__icon-close"
        alt="{{ 'COMMONS.CLOSE' | i18nextEager }}" />
      <div class="header__container-items">
        <div *ngFor="let item of contractsNotifications" class="header__item">
          <span class="header__circle-item "></span>
          <p *ngIf="!item.level && !item.idFichero">{{ item.socialReason }} - {{ item.campaign }}</p>
          <p *ngIf="item.level && !item.idFichero">{{ item.socialReason }} - {{ item.campaign }} - {{ item.level }}</p>
          <p *ngIf="item.idFichero">{{ item.nombreFichero }}</p>
          <img
            *ngIf="item.idFichero && item.resultOk"
            src="/assets/icons/download_red.svg"
            class="header__icon-item"
            (click)="downloadFile(item.idFichero)"
            alt="{{ 'COMMONS.DOWNLOAD' | i18nextEager }}"
          />
          <img
            *ngIf="item.registerCRM && item.resultOk && item.codeCRM"
            src="/assets/icons/arrow-right.svg"
            class="header__icon-item"
            (click)="handleNavigate(item)"
            alt="{{ 'COMMONS.NAVIGATE' | i18nextEager }}"
          />
          <img
            *ngIf="item.registerCRM && !item.resultOk && item.descriptionError"
            src="/assets/icons/rejected.svg"
            alt="{{ 'NEW_CONTRACTS.REJECTED' | i18nextEager }}"
            [matTooltip]="item.descriptionError"
            matTooltipPosition="above"
            class="header__icon-item"
          />
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="showSearch && !isUserSpanish" class="container-search">
    <img class="cursor-pointer" (click)="openHomeSearchDialog()" src="/assets/icons/search.svg"
      alt="{{ 'COMMONS.SEARCH' | i18nextEager }}" />
  </div>
  <div *ngIf="
      !onlyCanRead &&
      ((!router.url.includes('/incidents') && !router.url.includes('/resources') && !isExternal) ||
        (!router.url.includes('/incidents') && !router.url.includes('/resources')) ||
        router.url.includes('/incidents'))
    " class="container-buttons">
    <button *ngIf="!router.url.includes('/incidents') && !router.url.includes('/resources') && !isExternal"
      routerLink="/new-offer" class="element primary">
      {{ 'HOME.NEW_OFFER' | i18nextEager }}
    </button>
    <button
      *ngIf="!router.url.includes('/incidents') && !router.url.includes('/resources') && !router.url.includes('/co2')"
      routerLink="{{ isExternal ? '/new-contract-pymes' : '/new-contract-large-accounts' }}" class="element"
      [ngClass]="{ secondary: !isExternal }">
      {{ 'HOME.NEW_CONTRACT' | i18nextEager }}
    </button>
    <button *ngIf="router.url.includes('/incidents')" routerLink="/incidents/new" class="element">
      {{ 'INCIDENCE.NEW' | i18nextEager }}
    </button>
    <button *ngIf="router.url.includes('/co2')" routerLink="/co2/new" class="element">
      {{ 'CO2.NEW' | i18nextEager }}
    </button>
  </div>
  <button class="element element--not-margin-left user-menu user-menu--not-separator" mat-button
    [matMenuTriggerFor]="headerMenu" [ngClass]="{
      'user-menu--not-separator': router.url.includes('/resources') || (!showSearch && onlyCanRead)
    }">
    <h6>{{ name }}</h6>
    <p>{{ role | i18nextEager | uppercase }}</p>
  </button>
  <mat-menu #headerMenu="matMenu" xPosition="before" class="header__menu">
    <button *ngIf="isAllowImpersonalization" mat-menu-item class="header__option" (click)="impersonalizeDialog()">
      <mat-icon [svgIcon]="'impersonalize'" class="header__icon"></mat-icon>
      <span>{{ 'IMPERSONALIZE.TITLE' | i18nextEager }}</span>
    </button>
    <button *ngIf="isOneLoginUser" mat-menu-item class="header__option" (click)="openDeleteFactorsDialog()">
      <mat-icon [svgIcon]="'delete_factors'" class="header__icon"></mat-icon>
      <span>{{ 'DELETE_FACTORS.TITLE' | i18nextEager }}</span>
    </button>
    <button *ngIf="isUserSpanish ? (isExternal && notComercial && !onlyCanRead) : isResponsable" mat-menu-item
      class="header__option" routerLink="/user-management">
      <mat-icon [svgIcon]="'user_management'" class="header__icon"></mat-icon>
      <span>{{ 'BREADCRUMBS.USER_MANAGEMENT' | i18nextEager }}</span>
    </button>
    <button mat-menu-item class="header__option" (click)="openLanguagesDialog()">
      <mat-icon [svgIcon]="'languages'" class="header__icon rotate90"></mat-icon>
      <span>{{ 'BREADCRUMBS.LANGUAGES' | i18nextEager }}</span>
    </button>
    <button *ngIf="multipleCountries" mat-menu-item class="header__option" (click)="openCountriesDialog()">
      <mat-icon [svgIcon]="'countries'" class="header__icon"></mat-icon>
      <span>{{ 'BREADCRUMBS.COUNTRIES' | i18nextEager }}</span>
    </button>
    <button *ngIf="isOneLoginUser" mat-menu-item class="header__option" (click)="openChangePasswordDialog()">
      <mat-icon [svgIcon]="'password'"></mat-icon>
      <span>{{ 'BREADCRUMBS.CHANGE_PASSWORD' | i18nextEager }}</span>
    </button>
    <button mat-menu-item class="header__option" (click)="logout()">
      <mat-icon [svgIcon]="'exit'" class="header__icon"></mat-icon>
      <span>{{ 'COMMONS.EXIT' | i18nextEager }}</span>
    </button>
  </mat-menu>
</header>